export const formatAmount = (Num) => {
    //
    const Amt = parseFloat(Num)
    // 
    const Split = Amt.toFixed(2).split('.')

    return parseFloat(Split[0]).toLocaleString()+"."+Split[1]
}
  